import { FC } from "react";

interface IconProps {
  color: string;
}

export const TickIcon: FC<IconProps> = ({ color }) => {
  return (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5547 0.999269C16.1484 1.59298 16.1484 2.5502 15.5547 3.14391L6.6914 12.0012C6.09769 12.5949 5.14048 12.5949 4.54676 12.0012L0.445286 7.89363C-0.148429 7.29991 -0.148429 6.3427 0.445286 5.74899C1.039 5.15527 1.99621 5.15527 2.58993 5.74899L5.62514 8.7842L13.4161 0.993211C14.0038 0.405554 14.961 0.405554 15.5547 0.999269Z" fill={color} />
    </svg>
  );
};
